"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeEditorProvider = ChallengeEditorProvider;
exports.useChallengeReadOnly = useChallengeReadOnly;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ChallengeEditorContext = (0, react_1.createContext)(false);
function ChallengeEditorProvider(_a) {
    var isReadOnly = _a.isReadOnly, children = _a.children;
    return (0, jsx_runtime_1.jsx)(ChallengeEditorContext.Provider, { value: isReadOnly, children: children });
}
function useChallengeReadOnly() {
    return (0, react_1.useContext)(ChallengeEditorContext);
}
